import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {Link, useNavigate} from 'react-router-dom';
import {LogoutOutlined} from '@ant-design/icons';
import {Button, Dropdown, Space} from 'antd';
import {observer} from 'mobx-react-lite';

import {INDEX, LOGIN, REGISTRATION} from '../../config/routes';
import {Store} from '../../model/store/Store';

import logo from './GetMoneyLogo.svg';
import {SelectGeo} from './SelectGeo';

import cls from './Header.module.scss';


function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

const Header = observer(() => {

    const {t} = useTranslation();
    const navigate = useNavigate()
    const {auth} = useInstance(Store)

    const [width, setWidth] = useState(getWindowDimensions().width);
    useEffect(() => {
        function handleResize() {
            setWidth(getWindowDimensions().width);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const small = width <= 600;

    return (
        <div className={cls.header}>
            <div className={cls.top}>
                <div>
                    <Link to={INDEX}>
                        <img src={logo} alt={'Get Money Logo'} className={cls.logo}/>
                    </Link>
                </div>
                <Space direction={small ? 'vertical' : 'horizontal'}>
                    <div>
                        {auth.auth
                            ?
                            <Dropdown menu={{items: [{key: 'exit', label: t('Logout'), onClick: () => auth.clearState()}]}}>
                                <Button size={small ? 'small' : 'large'} className={cls.button}>
                                    <div className={cls.buttonName}><LogoutOutlined/> {auth.FIO}</div>
                                </Button>
                            </Dropdown>
                            :
                            <Space>
                                <Button size={small ? 'small' : 'large'} onClick={() => navigate(LOGIN)}>{t('Login')}</Button>
                                <Button size={small ? 'small' : 'large'} onClick={() => navigate(REGISTRATION)}>{t('Registration')}</Button>
                            </Space>
                        }
                    </div>
                    {/*<Button size={'large'} icon={<MenuOutlined/>}/>*/}
                    <Space>
                        <SelectGeo small={small}/>
                    </Space>
                </Space>
            </div>
        </div>
    )
})

export default Header;